<div class="modal-header border-2 h5 modal-header pb-2 pt-2 text-bg-warning">
  Currently Active Documents from the same case
  <div
    class="h6"
    triggers="hover"
    ngbTooltip="You need to take over the remaining open documents from the same case to prevent data loss and maintain answer integrity.">
    What is this?
    <i class="bi-question-circle-fill text-ellipsis h6"></i>
  </div>
  <button *ngIf="closeEnabled" type="button" class="btn btn-titlebar" (click)="activeModal.dismiss()" title="Close">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body px-0 pt-0">
  <ul ngbNav #nav="ngbNav" class="border-3 nav nav-tabs ps-2 w-100" [destroyOnHide]="false" [(activeId)]="activeTabId">
    <li [ngbNavItem]="session.sessionId" *ngFor="let session of activeSessions">
      <button ngbNavLink class="pe-2">
        {{ session.filename }}
        <a
          class="m-2 ps-3"
          [href]="getResumeSessionUrl(session.sessionId, session.filename)"
          target="_blank"
          (click)="completeTakeover(session, $event)">
          <i class="bi bi-box-arrow-up-right"></i>
        </a>
      </button>

      <ng-template ngbNavContent>
        <div class="mt-0 position-relative interaction-prevent">
          <div class="iframe-overlay align-content-center d-flex justify-content-center">
            <div class="card interaction-forced shadow-heavy mt-7" style="height: 175px">
              <div class="align-items-baseline card-header d-flex justify-content-between text-bg-primary">
                <h5>Read-Only View</h5>
                <div
                  triggers="hover"
                  ngbTooltip="When documents are taken over, all documents of that same case must be taken over.                  "
                  class="h6">
                  <i class="bi-question-circle-fill text-ellipsis h6"></i>
                </div>
              </div>
              <div class="card-body">
                <p>
                  This is a read-only view of:
                  <br />
                  <strong>{{ session.filename }}</strong>
                </p>
                <p class="text-center">
                  Click
                  <a
                    [href]="getResumeSessionUrl(session.sessionId, session.filename)"
                    target="_blank"
                    (click)="completeTakeover(session)">
                    here
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                  to open this document in a new tab
                </p>
              </div>
            </div>
          </div>
          <iframe *ngIf="session.url" [src]="session.url" tabindex="-1" class="dimmed-iframe"></iframe>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
